import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from '@/views/HomeView.vue'
import NotFoundView from '@/views/NotFoundView.vue'

Vue.use(VueRouter)

// One long marketing page - the navbar links are in-page anchors
// (#approach, #methods, ...), not separate routes.
const routes = [
    { path: '/', name: 'home', component: HomeView },
    { path: '*', name: 'not-found', component: NotFoundView },
]

export const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        if (to.hash) return { selector: to.hash, offset: { x: 0, y: 72 }, behavior: 'smooth' }
        return { x: 0, y: 0 }
    },
})
